var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.60352C10.8896 6.60352 4.68262 18.5391 4.68262 22.0459C4.7373 23.1055 5.1748 28.3897 8.52441 28.3897H25.7168L26.0928 28.0137C26.2637 27.8428 30.3105 23.7275 30.3105 18.1357C30.3174 12.4277 23.8506 6.60352 17.5 6.60352ZM10.6846 14.4717C12.2158 14.8477 15.4492 15.5791 17.5 15.5791C17.876 15.5791 18.0879 15.6338 18.1904 15.6816C18.1084 15.9072 17.7734 16.4336 16.8027 17.0693C14.7656 18.3955 13.5488 19.8721 12.9609 20.7061H7.49219C7.9707 19.0928 9.15332 16.6729 10.6846 14.4717ZM24.623 25.833H8.52441C8.16211 25.833 7.65625 24.6914 7.39648 23.2695H14.4238L14.7861 22.5928C14.793 22.5723 15.7842 20.7949 18.2041 19.2158C20.1797 17.9307 21.1025 16.3174 20.6787 14.8955C20.3301 13.7197 19.1406 13.0156 17.5 13.0156C16.1191 13.0156 13.9795 12.5986 12.4277 12.25C14.0205 10.4727 15.8047 9.17383 17.5 9.17383C22.4834 9.17383 27.7539 13.7881 27.7539 18.1494C27.7539 21.7998 25.4912 24.8076 24.623 25.833Z",
    fill: "#14171F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacing);
export default __webpack_public_path__ + "static/media/racing.fca140c88dcad124ac8dcce2668384cb.svg";
export { ForwardRef as ReactComponent };